// extracted by css-extract-rspack-plugin
export default {"icon":"icon-Vht8Yi","icon_color_fill":"icon_color_fill-Zo3hnP","iconColorFill":"icon_color_fill-Zo3hnP"};